import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { Action, Collaboration, GetCollaborationQuery, GetCollaborationQueryVariables, OrgType } from '../../../../API';
import { GetCollaboration } from '../../../../graphql/queries';
import { UserManagementService } from '../../../shared/services/user-management.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-accept-invitation',
  templateUrl: './accept-invitation.component.html',
  styleUrl: './accept-invitation.component.scss',
})
export class AcceptInvitationComponent implements OnInit {
  @Output() isFormValid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() updateOwnerOrgType: EventEmitter<string> = new EventEmitter<string>();

  collaborationId!: string;
  collaborationDetails?: Collaboration;
  agreeFormControl: UntypedFormControl = new FormControl(false);
  isLoading: boolean = false;

  constructor(
    private apiService: ApiService,
    private userManagementService: UserManagementService,
    private nzMessageService: NzMessageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    this.collaborationId = this.activatedRoute.snapshot.paramMap.get('collaborationId') ?? '';

    this.getCollaborationDetails();

    this.agreeFormControl.valueChanges.subscribe((newValue) => {
      this.isFormValid.emit(newValue);
    });
  }

  getCollaborationDetails() {
    this.isLoading = true;
    this.apiService
      .query<GetCollaborationQuery, GetCollaborationQueryVariables>(GetCollaboration, {
        collaborationRequest: {
          orgType: this.userManagementService.getOrgType(),
          collaborationId: this.collaborationId,
          loggedInUserOrg: this.userManagementService.getOrganizationType() as OrgType,
          action: Action.GET_COLLABORATION,
        },
      })
      .then((result) => {
        const collaborationDetails = result.data?.GetCollaboration;
        if (collaborationDetails) {
          this.collaborationDetails = collaborationDetails.data as Collaboration;
          this.updateOwnerOrgType.emit(this.collaborationDetails.orgType);
        } else {
          this.nzMessageService.error('Failed to fetch collaboration details');
        }
      })
      .catch((error) => {
        this.nzMessageService.error(error?.message ?? 'Failed to fetch collaboration details');
      })
      .finally(() => (this.isLoading = false));
  }

  redirectToList() {
    this.router.navigate(['../../list'], { relativeTo: this.activatedRoute });
  }
}
